import { Link } from "@tanstack/react-router"
import { CardDescription, CardTitle } from "design-system/molecules/Card"
import { useSignupMutation } from "modules/auth/hooks/useSignupMutation"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { SignupSchema } from "schema"
import { z } from "zod"
import { AuthWrapper } from "../AuthWrapper"
import { SignupForm } from "./SignupForm"

export const Signup = () => {
  const { t } = useTranslation()
  const [isRequested, setIsRequested] = useState<boolean>(false)
  const { mutateAsync, isPending } = useSignupMutation()

  const onSubmitSignup = async (data: z.infer<typeof SignupSchema>) => {
    await mutateAsync(data)
    setIsRequested(true)
  }

  return (
    <AuthWrapper>
      <div className="flex flex-col gap-4 w-full justify-center items-center">
        {isRequested ? (
          <div className="flex flex-col gap-2 items-center text-center">
            <CardTitle>{t("auth.signup.success.title")}</CardTitle>
            <CardDescription>{t("auth.signup.success.body")}</CardDescription>
          </div>
        ) : (
          <>
            <SignupForm onSubmit={onSubmitSignup} isPending={isPending} />
            <div className="text-center text-sm">
              <Trans
                i18nKey={"auth.signup.goToLogin"}
                components={{
                  b: <Link className="underline inline hover:text-foreground/80" to="/login" />,
                }}
              />
            </div>
          </>
        )}
      </div>
    </AuthWrapper>
  )
}
